import React, { memo, useMemo } from "react";

import { Navigate } from "react-router-dom";
import { modules } from "byzantine";
import { type WireType } from "byzantine/src/dbbl/businessLogic/modules/internationalWires/WireTransferContainer.form";

import TfaVerify from "../../../../../../components/verify/TfaVerify";

import { useSendViaTemplate } from "./SendViaTemplate.container";
import Form from "./Form";
import Review from "./Review";

import "./SendViaTemplate.module.scss";

function SendViaTemplateScreen({
  setWireType,
  wireType,
}: {
  setWireType: (wireType: WireType) => void;
  wireType: WireType;
}) {
  const { uiState, submitForm, complete2FA, submitReview, resetFlow, loading } =
    useSendViaTemplate();

  const content = useMemo(() => {
    switch (uiState) {
      case "2FA": {
        return <TfaVerify goToReview={complete2FA} cancelAction={resetFlow} />;
      }
      case "review": {
        return (
          <Review
            onSubmit={submitReview}
            loading={loading}
            goBack={resetFlow}
          />
        );
      }
      default: {
        return (
          <Form
            onSubmit={submitForm}
            setWireType={setWireType}
            wireType={wireType}
          />
        );
      }
    }
  }, [
    uiState,
    complete2FA,
    resetFlow,
    submitReview,
    loading,
    submitForm,
    setWireType,
    wireType,
  ]);

  const { hasFedwireTemplatePermission, fedwireTemplatesEnabled } =
    modules.wireTemplates.useWirePermissions();
  if (!hasFedwireTemplatePermission || !fedwireTemplatesEnabled) {
    return <Navigate to={"/"} replace />;
  }

  return content;
}

export default memo(SendViaTemplateScreen);
